t = require('views/internal/teacup-with-helpers')('kiln_changeset_thumbnail')

module.exports = ->
  t.span { title: t.mustacheVar('commitMessage') }, ->
    t.text t.mustacheVar('shortCommitMessage')

  t.span '.block.quiet', ->
    reviews = t.mustacheVar('reviews') ? []
    date = t.mustacheVar('date')

    if reviews.length == 0 && !date
      t.format 'no-reviews-no-date'
    else if reviews.length == 0 && date
      t.format 'no-reviews-date', { date }
    else if reviews.length > 0 && !date
      t.format 'reviews-no-date'
    else if reviews.length > 0 && date
      t.format 'reviews-date', { date }

    t.mustacheBlock 'reviews', ->
      t.span ->
        t.a { href: t.mustacheVar('url'), target: '_blank' }, ->
          t.text t.mustacheVar('status')




// WEBPACK FOOTER //
// ./app/scripts/views/templates/kiln_changeset_thumbnail.coffee